import { chakra, UseCheckboxProps, useCheckbox, Text } from '@chakra-ui/react';
import { checkboxButtonSx } from './styles';

export interface CheckboxButtonProps extends UseCheckboxProps {
  buttonTitle: string;
}

export const CheckboxButton = ({
  buttonTitle,
  ...props
}: CheckboxButtonProps) => {
  const { state, getInputProps, getLabelProps, htmlProps } = useCheckbox(props);
  const styles = checkboxButtonSx(state.isChecked);
  return (
    <chakra.label
      sx={styles.container}
      cursor={state.isDisabled ? 'not-allowed' : 'pointer'}
      opacity={state.isDisabled ? 0.36 : 1}
      {...htmlProps}
    >
      <input {...getInputProps()} hidden />
      <Text sx={styles.text} {...getLabelProps()}>
        {buttonTitle}
      </Text>
    </chakra.label>
  );
};
